namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');
compass.requireLib('compass.group.NamesHelper');

compass.hotel.EditReservationDatesWidget = compass.defineWidget(function EditReservationDatesWidget(options) {

	var me = this;
	var $j = jQuery;
	var _d = jQuery.dom;

	var _settings = options;

	if(_settings.translate)
	{
		_settings.nights = _.map(_settings.nights, function(night,index) {
			return {
				"roomPrice" : night.availBase.roomPrice,
				"inclusiveRoomPrice" : (night.availBase.inclusiveRoomPrice || night.availBase.roomPrice),
				"date" : night.nightBase.night,
				"availInfo" : night.availBase.availInfo,
				"currencySymbol" : "$"

			};
		});
	}
	var _WUID = _settings.WUID;

	var fullDateFormat = compass.util.dateFormatter('ddd, mmm d, yyyy');

	var _currentCheckIn = _.find(_settings.nights, function(n) { return n.date == _settings.currentCheckInDate; } );
	var _currentCheckOut = _.find(_settings.nights, function(n) { return n.date == _settings.currentCheckOutDate; } );

	var _checkInSelect;
	var _checkOutSelect;

	this.getArriveDepart = function(){
		return {
			"arrive" : _currentCheckIn ? _currentCheckIn.date : null,
			"depart" : _currentCheckOut ? _currentCheckOut.date : null
		};		
	};

	this.grabValues = function() {
		if(!_currentCheckIn || !_currentCheckOut) {
			return {
				nights : [],
				stays : []
			};
		}
		var chosenNights = _.chain(_settings.nights)
			.filter(function(n) {
				return n.date >= _currentCheckIn.date && n.date <= _currentCheckOut.date;
			})
			.map(function(n) {
				return {
					nightDate : n.date,
					fulldate : n.date,
					date : n.date,
					roomPrice : n.roomPrice,
					inclusiveRoomPrice : (n.inclusiveRoomPrice||n.roomPrice),
					numRooms : _currentCheckOut.date === n.date ? 0 : 1
				};
			})
			.value();

		var stays = [ ];
		if (chosenNights.length > 1) {
			stays.push({
				arrive : _.first(chosenNights).date,
				depart : _.last(chosenNights).date,
				rooms : 1
			});
		}

		return {
			nights : chosenNights,
			stays : stays
		};
	};

	this.validationMessage = function() {
		/*there is no error if they haven't picked both arrive and a depart date */
		if ( _currentCheckOut == null || _currentCheckIn == null){ return '';}
		
		if ( !_.chain(_settings.nights)
			.filter(function(n) {
				return n.date >= _currentCheckIn.date && n.date < _currentCheckOut.date;
			})
			.every(function(n) {
				return n.availInfo === 'AVAIL';
			}).value() ) {
			return 'One or more nights selected are not available';
		}

		if ( _.filter(_settings.nights, function(n) {
				return n.date >= _currentCheckIn.date && n.date < _currentCheckOut.date;
			}).length < _settings.minimumNights) {
			return 'Minimum stay of ' + _settings.minimumNights + ' nights is required for this room type.';
		}

		return '';
	};

	this.render = function(widgetElem) {
		widgetElem.append(
			_d.fieldLabelPair({ label : 'Check-In'},
				[me.drawCheckIn()]
			),
			_d.fieldLabelPair({ label : 'Check-Out'},
				[me.drawCheckOut()]
			)
		);
	};

	var makeDropDownInvalid = function(dataSelect, errorMessage){
		return _d.errorBubble({
			elem : dataSelect,
			errorMessage : errorMessage
		});
	};

	var makeDropDownValid = function(dataSelect){
		dataSelect.removeClass('invalid');
		dataSelect.find('.reqHint').remove();
	};

	this.validateDates = function(){
		var checkInGood = me.validateCheckIn();
		var checkOutGood = me.validateCheckOut();
		return checkInGood && checkOutGood;
	};

	this.validateCheckIn = function(){
		var checkInSelect = me.find('.checkInSelect');
		/*!_settings.currentCheckInDate tells us the dropdown did not have an initial selection (but had a placeholder like 'choose date') */
		/* we don't want to actually validate any date ranges until the user chooses an actual date */
		if(!_settings.currentCheckInDate && !_currentCheckIn){
			makeDropDownInvalid(checkInSelect, 'A check-in date is required');
			return false;
		}
		var dateRangeErrorMessage = me.validationMessage();
		if (dateRangeErrorMessage !== '') {
			makeDropDownInvalid(checkInSelect, dateRangeErrorMessage);
			return false;
		}
		/*if we have passed all the date validation, make it valid */
		makeDropDownValid(checkInSelect);
		return true;
	};

	this.validateCheckOut = function(){
		var checkOutSelect = me.find('.checkOutSelect');
		if(!_settings.currentCheckOutDate && !_currentCheckOut){
			makeDropDownInvalid(checkOutSelect, 'A check-out date is required');
			return false;
		}
		var dateRangeErrorMessage = me.validationMessage();
		/*there is no placeholder text or there is but the date actually is a valid date chosen, so just validate date ranges */
		if (dateRangeErrorMessage !== '') {
			makeDropDownInvalid(checkOutSelect, dateRangeErrorMessage);
			return false;
		}
		/*if we have passed all the date validation, make it valid */
		makeDropDownValid(checkOutSelect);
		return true;
	};

	this.drawCheckIn = function() {

		var initialSelection = _.indexOf(_settings.nights, _currentCheckIn);
		
		_checkInSelect = _d.dataSelect({
			data : _settings.nights,
			initialSelection : initialSelection,
			className : 'checkInSelect',
			disabledClassName : 'unavailableRow',
			labelMapper : _labelMapper,
			choiceMapper : _choiceMapper,
			classMapper : function(data) {
				if (data.availInfo != 'AVAIL') {
					return 'unavailableRow';
				}
				return '';
			},
			change : function(data) {
				var nh = compass.group.NamesHelper;
				_currentCheckIn = data;
				var _nights = _settings.nightsBasedOnCheckin.length > 0 ? _settings.nightsBasedOnCheckin : _settings.nights;
				var nightsAfterCheckIn = _.filter(_nights, function(n) { return n.date > _currentCheckIn.date; } );

				var arriveOfBookedReservation = '';
				var departOfBookedReservation = '';
				/*this can either be an array of no names or the one currently assigned reservation if it's in an assigned room*/
				if(_settings.unassignedRoomsInfo.length){
					var farthestNoName = nh.getFarthestNoNameReservation(_settings.unassignedRoomsInfo);
					arriveOfBookedReservation = farthestNoName.arrive;
					departOfBookedReservation = farthestNoName.depart;
				}
				else{
					/*if this is an assigned room for 20th and the 26th, then we will merge with this assigned reservation's information, but only for teh 20th-26th */
					arriveOfBookedReservation = compass.util.parse.ISODateParser(_settings.currentCheckInDate);
					departOfBookedReservation = compass.util.parse.ISODateParser(_settings.currentCheckOutDate);
				} 
				nightsAfterCheckIn = nh.mergeGeneralAvailWithReservation(nightsAfterCheckIn, arriveOfBookedReservation, departOfBookedReservation);

				var currentCheckoutOnly = _.find(nightsAfterCheckIn, function(n) { return n.availInfo === 'CHECKOUT'; } );
				if (currentCheckoutOnly) {
					currentCheckoutOnly.availInfo = 'OUT';
				}
				var firstUnavailable = _.find(nightsAfterCheckIn, function(n) { return n.availInfo != 'AVAIL'; } );
				if (firstUnavailable) {
					firstUnavailable.availInfo = 'CHECKOUT';
				}

				var areDatesEqual = function(nightStruct1, nightStruct2){
					if(nightStruct1 && nightStruct2){
						return nightStruct1.date == nightStruct2.date ? true : false;
					}
					else if(!nightStruct1 && !nightStruct2){
						/*both dates undefined */
						return true;
					}
					else{
						return false;
					}
				};

				me.find('.checkOutSelect').trigger('rebuildContent', { choices: nightsAfterCheckIn, comparator: areDatesEqual });
				if (_currentCheckOut == null || (nightsAfterCheckIn.length > 0 && nightsAfterCheckIn[0].date > _currentCheckOut.date)) {
					_currentCheckOut = nightsAfterCheckIn[0];
				}

				// trigger rebuild could set a new date. we need to get it into _currentCheckout
				if ( _currentCheckOut == null ){
					_currentCheckout = _checkOutSelect.currentData;
				}

				me.validateDates();
				me.trigger("EditReservationDatesWidget.datesChange", "Check-In" );
				
				currentArriveDepart = me.getArriveDepart();
				if ( currentArriveDepart.arrive && currentArriveDepart.depart ) me.trigger("EditReservationDatesWidget.earnedCompsChange", currentArriveDepart );
				
				_settings.onChange();
			},
			idGenerator : compass.generateId,
			preHandleClick : _settings.preHandleClick
		});

		return _checkInSelect;

	};

	this.disableDropDown = function() {
		me.find('.checkInSelect, .checkOutSelect').trigger('disable');
	};

	this.enableDropDown = function() {
		me.find('.checkInSelect, .checkOutSelect').trigger('enable');
	};

	this.drawCheckOut = function() {

		if ( _currentCheckIn ){
			var nightsAfterCheckIn = _.filter(_settings.nights, function(n) { return n.date > _currentCheckIn.date; } );
		}
		else {
			var nightsAfterCheckIn = _settings.nights;
		}
		
			var currentCheckOutIndex = _.indexOf(nightsAfterCheckIn, _currentCheckOut);
			var firstUnavailable = _.find(nightsAfterCheckIn, function(n) { return n.availInfo != 'AVAIL'; } );
			if (firstUnavailable) {
					firstUnavailable.availInfo = 'CHECKOUT';
				}

		_checkOutSelect = _d.dataSelect({
			data : nightsAfterCheckIn,
			initialSelection : currentCheckOutIndex,
			className : 'checkOutSelect',
			disabledClassName : 'unavailableRow',
			labelMapper : _labelMapper,
			choiceMapper : _choiceMapper,
			classMapper : function(data) {
				if (data.availInfo === 'CHECKOUT') {
					return 'checkoutOnlyRow';
				}
				else if (data.availInfo != 'AVAIL') {
					return 'unavailableRow';
				}
				return '';
			},
			change : function(data) {
				_currentCheckOut = data;
				me.validateDates();
				me.trigger("EditReservationDatesWidget.datesChange", "Check-Out");
				
				currentArriveDepart = me.getArriveDepart;				
				if ( currentArriveDepart.arrive && currentArriveDepart.depart ) me.trigger("EditReservationDatesWidget.earnedCompsChange", currentArriveDepart );
				_settings.onChange();
			},
			idGenerator : compass.generateId,
			preHandleClick : _settings.preHandleClick
		});

	return _checkOutSelect;

	};

	var isDateInDateRange = function (dateToCheckString, rangeBeginString, rangeEndString){
		var dateToCheck = compass.util.parse.ISODateParser(dateToCheckString);
		var beginDate = compass.util.parse.ISODateParser(rangeBeginString);
		var endDate = compass.util.parse.ISODateParser(rangeEndString);
		if(dateToCheck >= beginDate && dateToCheck <= endDate)
			return true;
		else{
			return false;
		}
	};

	this.setMinimumNights = function(minNights){
		_settings.minimumNights = minNights;
	};

	var _labelMapper = function(data) {
		return (data != null ? fullDateFormat(compass.util.parse.ISODateParser(data.date)) : _settings.selectOptionText);
	};

	var _choiceMapper = function(data) {
		var option = _d.div();
		option.append(
			(data.inclusiveRoomPrice||data.roomPrice) > 0 ? _d.div({ className : 'dateChangeColumn price' }, (data.inclusiveRoomPrice||data.roomPrice) > 0 ? data.currencySymbol + (data.inclusiveRoomPrice||data.roomPrice) : '') : null,
			_d.div({ className : 'dateChangeColumn date' }, fullDateFormat(compass.util.parse.ISODateParser(data.date))),
			_d.div({ className : 'dateChangeColumn availableStatus'},
				_d.div({ className : 'unavailableText'}, 'UNAVAILABLE'),
				_d.div({ className : 'checkoutOnlyText'}, 'Check-out Only')
			)
		);
		return option;
	};
	
}, {
	WUID : 'defaultEditReservationDatesWidget',
	widgetName : 'EditReservationDatesWidget',
	nights : [ ],
	unassignedRoomsInfo : [],
	nightsBasedOnCheckin : [],/* room types that whose availability information doesn't get changed when the initial check in dropdown gets clicked (this availability is used after a checkin date is selected)*/
	currentRoomTypeIndex : 0,
	currentCheckInDate : undefined,
	currentCheckOutDate : undefined,
	minimumNights : 1,
	translate : false,
	selectOptionText: 'Choose a date',
	preHandleClick : function(){return true;},
	onChange: function(){}
});
